import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-frm-forms-create-result-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class FrmFormsCreateResultApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("tableOfContents.createFormResult"),
            description: this.translation.t("specs.createFormResultDescription"),
            httpMethod: "POST",
            path: "/formsdata/{id}/results",

            parameters: [
                {
                    name: "id",
                    description: this.translation.t("parameters.formsIdDescription"),
                    in: "path",
                    paramType: "integer",
                    required: true,
                    example: "12",
                },
                {
                    name: '"Field Name"',
                    description: this.translation.t("parameters.formsFieldNameDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: {
                        "Form Field Text": "Value A",
                        "Form Field Number A": 123,
                        "Form Field Number B": "123",
                        "Form Field Date A": "2025-12-31",
                        "Form Field Date Time A": "2025-12-31T14:12:00+1",
                    },
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
